var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.069,
    height: 22.216,
    viewBox: "0 0 24.069 22.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "angles-right-solid",
    d: "M44.393,73.825l-9.257-9.257a1.851,1.851,0,0,0-2.618,2.618l7.952,7.947-7.95,7.95A1.85,1.85,0,1,0,35.137,85.7l9.257-9.257A1.85,1.85,0,0,0,44.393,73.825Zm11.109,0-9.257-9.257a1.851,1.851,0,0,0-2.618,2.618l7.952,7.947-7.95,7.95A1.85,1.85,0,1,0,46.245,85.7L55.5,76.441A1.85,1.85,0,0,0,55.5,73.825Z",
    transform: "translate(-31.975 -64.025)",
    fill: "#9c9a9a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.54ee35277ac9b4236e942fc4d8f4e174.svg";
export { ForwardRef as ReactComponent };